import { render, staticRenderFns } from "./creatTask.vue?vue&type=template&id=e45f1fe8&scoped=true"
import script from "./creatTask.vue?vue&type=script&lang=js"
export * from "./creatTask.vue?vue&type=script&lang=js"
import style0 from "./creatTask.vue?vue&type=style&index=0&id=e45f1fe8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45f1fe8",
  null
  
)

export default component.exports